var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.28 4.68066V12.2167C15.2801 12.4049 15.2064 12.5856 15.0748 12.7202C14.9433 12.8548 14.7642 12.9325 14.576 12.9367H1.42403C1.23586 12.9325 1.05681 12.8548 0.925227 12.7202C0.793642 12.5856 0.719985 12.4049 0.720032 12.2167V4.68066",
    stroke: "#F5B335",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21598 2.39258C3.17784 2.47845 3.15613 2.57071 3.15198 2.66458C3.17697 2.82701 3.25927 2.97513 3.384 3.08213C3.50873 3.18914 3.66764 3.24797 3.83198 3.24797C3.99632 3.24797 4.15523 3.18914 4.27996 3.08213C4.40468 2.97513 4.48699 2.82701 4.51198 2.66458C4.50783 2.57071 4.48612 2.47845 4.44798 2.39258",
    stroke: "#F5B335",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83984 2.64845V1.06445",
    stroke: "#F5B335",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7839 2.39258C12.8221 2.47845 12.8438 2.57071 12.8479 2.66458C12.8229 2.82701 12.7406 2.97513 12.6159 3.08213C12.4912 3.18914 12.3323 3.24797 12.1679 3.24797C12.0036 3.24797 11.8447 3.18914 11.7199 3.08213C11.5952 2.97513 11.5129 2.82701 11.4879 2.66458C11.4921 2.57071 11.5138 2.47845 11.5519 2.39258",
    stroke: "#F5B335",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1602 2.64845V1.06445",
    stroke: "#F5B335",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4238 1.49609H4.57581",
    stroke: "#F5B335",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08803 1.49609H1.42403C1.23586 1.50028 1.05681 1.57798 0.925227 1.71255C0.793642 1.84713 0.719985 2.02788 0.720032 2.21609V4.68009H15.28V2.21609C15.2801 2.02788 15.2064 1.84713 15.0748 1.71255C14.9433 1.57798 14.7642 1.50028 14.576 1.49609H12.912",
    stroke: "#F5B335",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/calendar_blue.8e044889.svg";
export { ForwardRef as ReactComponent };